import EvereeViewStore from "./Everee.Store";
import EvereeWorkerManagementStore from "./admin/workers/EvereeWorkerManagement.Store";
import EvereeTimesheetManagementStore from "./admin/timesheets/EvereeTimesheetManagement.Store";
import EvereePayrollOperationsStore from "./admin/operations/EvereePayrollOperations.Store";
import EvereeWorkLocationsStore from "./admin/locations/EvereeWorkLocations.Store";
import EvereeFinancialReportsStore from "./admin/reports/EvereeFinancialReports.Store";
// Profile management stores
import EarningProfilesStore from "./admin/profiles/earnings/EarningProfiles.Store";
import DeductionProfilesStore from "./admin/profiles/deductions/DeductionProfiles.Store";
// LNI management store
import LNICodesStore from "./admin/lni/LNICodes.Store";
// Vending integration store
import VendingIntegrationStore from "./admin/vending/VendingIntegration.Store";
// Bulk paystub store
import BulkPaystubStore from "./admin/bulkpaystubs/BulkPaystub.Store";

const payrollStoreList = [
  // Worker self-service store
  { name: "evereeViewStore", store: EvereeViewStore },
  // Admin stores
  { name: "evereeWorkerManagementStore", store: EvereeWorkerManagementStore },
  { name: "evereeTimesheetManagementStore", store: EvereeTimesheetManagementStore },
  { name: "evereePayrollOperationsStore", store: EvereePayrollOperationsStore },
  { name: "evereeWorkLocationsStore", store: EvereeWorkLocationsStore },
  { name: "evereeFinancialReportsStore", store: EvereeFinancialReportsStore },
  // Profile management stores
  { name: "earningProfilesStore", store: EarningProfilesStore },
  { name: "deductionProfilesStore", store: DeductionProfilesStore },
  // LNI management store
  { name: "lniCodesStore", store: LNICodesStore },
  // Vending integration store
  { name: "vendingIntegrationStore", store: VendingIntegrationStore },
  // Bulk paystub store
  { name: "bulkPaystubStore", store: BulkPaystubStore },
];

export default payrollStoreList;
